/* Lumora Atelier: inschuiven, menu, header, winkelmandje */
(function () {
  var root = document.documentElement;

  /* Inschuiven bij scrollen */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function observe(scope) {
    (scope || document).querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  }
  observe();
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  /* Header verbergt zich bij naar beneden scrollen, komt terug bij omhoog */
  var header = document.querySelector('.site-header');
  var lastY = window.scrollY, ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !header) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      header.classList.toggle('is-hidden', y > lastY && y > 240 && !root.classList.contains('menu-open'));
      lastY = y; ticking = false;
    });
  }, { passive: true });

  /* Mobiel menu: openen, sluiten (kruisje, Escape, achtergrond) en aangetikte link markeren tijdens het laden */
  var menu = document.getElementById('MenuOverlay');
  function setMenu(open) {
    root.classList.toggle('menu-open', open);
    document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (menu) menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open && menu) { var c = menu.querySelector('[data-menu-close]'); if (c) setTimeout(function () { c.focus(); }, 50); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { setMenu(!root.classList.contains('menu-open')); return; }
    if (e.target.closest('[data-menu-close]')) { setMenu(false); return; }
    var link = e.target.closest('.menu-link');
    if (link) {
      menu.querySelectorAll('.menu-link').forEach(function (a) { a.classList.remove('is-loading'); });
      link.classList.add('is-loading');
      if (link.pathname === location.pathname) { e.preventDefault(); setTimeout(function () { setMenu(false); link.classList.remove('is-loading'); }, 250); }
    }
  });
  window.addEventListener('pageshow', function () { setMenu(false); if (menu) menu.querySelectorAll('.is-loading').forEach(function (a) { a.classList.remove('is-loading'); }); });

  /* Winkelmandje-lade */
  var drawer = document.getElementById('CartDrawer');
  function money(cents) {
    return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: window.LumoraCurrency || 'EUR' }).format(cents / 100);
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    var body = drawer.querySelector('.drawer__body');
    var total = drawer.querySelector('[data-cart-total]');
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty"><p class="h3">Je mandje is leeg</p><p>Ontdek de collectie en vind jouw favoriet.</p><a class="link-arrow" href="/collections/all">Naar de collectie <span>→</span></a></div>';
    } else {
      body.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') : '';
        return '<div class="line"><img src="' + img + '" alt="" loading="lazy"><div><div class="line__name">' + it.product_title + '</div>' +
          (it.variant_title ? '<div class="line__meta">' + it.variant_title + '</div>' : '') +
          '<div class="line__qty"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Minder">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Meer">+</button></div></div>' +
          '<div class="line__price">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
    if (total) total.textContent = money(cart.total_price);
    var save = drawer.querySelector('[data-cart-save]');
    var saved = (cart.original_total_price || 0) - cart.total_price;
    if (save) { save.hidden = saved <= 0; save.textContent = saved > 0 ? 'Je bespaart ' + money(saved) + ' met je bundel' : ''; }
    renderUpsell(cart);
  }

  /* Aanvulling in het mandje: verwante producten die er nog niet in zitten */
  var upsellFor = null;
  function renderUpsell(cart) {
    var box = drawer && drawer.querySelector('[data-cart-upsell]');
    if (!box) return;
    if (!cart.items.length) { box.hidden = true; upsellFor = null; return; }
    var inCart = cart.items.map(function (it) { return it.product_id; });
    var key = inCart.join(',');
    if (upsellFor === key) return;
    upsellFor = key;
    fetch('/recommendations/products.json?product_id=' + inCart[0] + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var picks = (data.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; }).slice(0, 2);
        if (!picks.length) { box.hidden = true; return; }
        box.innerHTML = '<p class="drawer__upsell-title">Maak je routine compleet</p>' + picks.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
          return '<div class="upsell"><a href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy"></a><div><a class="line__name" href="' + p.url + '">' + p.title.split(' - ')[0] + '</a><div class="line__meta">' + money(v.price) + '</div></div>' +
            '<button class="upsell__add" type="button" data-upsell-add="' + v.id + '" aria-label="' + p.title.split(' - ')[0] + ' toevoegen">+ Toevoegen</button></div>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; });
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  window.LumoraCart = { open: function () { fetchCart().then(renderCart).then(openDrawer); }, refresh: function () { return fetchCart().then(renderCart); } };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); window.LumoraCart.open(); }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
    var add = e.target.closest('[data-upsell-add]');
    if (add) {
      add.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +add.dataset.upsellAdd, quantity: 1 }] }) })
        .then(function () { return window.LumoraCart.refresh(); });
    }
    var cardAdd = e.target.closest('[data-card-add]');
    if (cardAdd) {
      e.preventDefault();
      cardAdd.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +cardAdd.dataset.cardAdd, quantity: 1 }] }) })
        .then(function () { cardAdd.removeAttribute('aria-busy'); window.LumoraCart.open(); });
    }
    var q = e.target.closest('[data-line]');
    if (q) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.dataset.line, quantity: Math.max(0, +q.dataset.qty) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); root.classList.remove('menu-open'); } });

  /* Productformulier via AJAX, zodat Kaching-velden gewoon meegaan */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { window.LumoraCart.open(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });
})();
